import { useId } from 'react';

import { FORM_TOKEN_FIELD, HONEYPOT_FIELD } from '~/lib/form-guards';

/**
 * The invisible half of every public form: a honeypot and the signed render time.
 *
 * The honeypot is positioned off-screen rather than `display:none` — some bots
 * skip fields they can see are hidden — and is closed to humans from every
 * direction: `aria-hidden` keeps it from screen readers, `tabIndex={-1}` from
 * keyboard traversal, and `autoComplete="off"` from password managers, which
 * would otherwise fill it and get a real person rejected.
 */
export function FormGuards({ token }: { token: string }) {
  // The contact page renders three of these forms, so the id cannot be the field
  // name — that gave three elements one id, and a label pointing at whichever the
  // parser reached first.
  const uid = useId();
  return (
    <>
      <div aria-hidden="true" className="pointer-events-none absolute -left-[9999px] h-0 w-0 overflow-hidden">
        <label htmlFor={uid}>Reference</label>
        <input id={uid} type="text" name={HONEYPOT_FIELD} tabIndex={-1} autoComplete="off" defaultValue="" />
      </div>
      <input type="hidden" name={FORM_TOKEN_FIELD} value={token} />
    </>
  );
}
